module.exports = __webpack_public_path__ + "static/media/graph-bar.1ae16e67.svg";